var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAppIcon = function SvgAppIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 150 150",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-690,-230)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.394737,0,0,0.454545,607.105,125.455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M590,269.6C590,247.744 569.567,230 544.4,230L255.6,230C230.433,230 210,247.744 210,269.6L210,520.4C210,542.256 230.433,560 255.6,560L544.4,560C569.567,560 590,542.256 590,520.4L590,269.6Z",
    style: {
      fill: "url(#_Linear1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.909091,0,0,0.9,49.0909,22)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 727,
    y: 270,
    width: 77,
    height: 20,
    style: {
      fill: "rgb(199,206,211)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2987,0,0,0.9,-224.156,55)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 727,
    y: 270,
    width: 77,
    height: 20,
    style: {
      fill: "rgb(25,222,159)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.818182,0,0,0.9,152.182,88)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 727,
    y: 270,
    width: 77,
    height: 20,
    style: {
      fill: "rgb(212,35,100)"
    }
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(380,0,0,330,210,395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0,32,52)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "rgb(0,24,40)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 1
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AppIcon.7ffc1095.svg";
export { ForwardRef as ReactComponent };